//@ts-nocheck
import React from 'react';
import { SpringCards } from './ui/SpringCards';

export const WhyAccessibilityMatters: React.FC = () => {
  return (
    <div className="space-y-8">
      <div className="max-w-3xl mx-auto text-center">
        <h3 className="text-2xl font-semibold mb-4">Why Accessibility Matters in Fintech</h3>
        <p className="text-gray-600 mb-4">
          The tech, finance, and fintech industries often leave individuals behind due to:
        </p>
      </div>
      <SpringCards />
      <div className="max-w-3xl mx-auto text-center">
        <p className="text-xl font-semibold text-red-700">
          The Result? Millions are denied access to essential financial tools, hindering economic mobility and empowerment.
        </p>
      </div>
    </div>
  );
};

